/* eslint-disable @typescript-eslint/no-unused-vars */
import { ExpressionStrategy } from './ExpressionStrategy';
import { InputGraphNode } from '../../graph/InputGraphNode';
import { InputType } from '../types/Enum';
import { OutputGraphNode } from '../../graph/OutputGraphNode';
import { SeriesTypeNode } from './SeriesTypeNode';

export class ConstantNodeExpressionStrategy implements ExpressionStrategy {
    buildEngineNodeExpression(node: InputGraphNode): string {
        const operator = 'constant';
        const value = node.value?.toString();
        const createTimeSeries = node.createTimeSeries;
        if (createTimeSeries) {
            return `${operator}(${value})`;
        }
        return value;
    }
}

export class SimulationNodeExpressionStrategy
    extends SeriesTypeNode
    implements ExpressionStrategy
{
    buildEngineNodeExpression(node: InputGraphNode): string {
        const {
            dbid,
            analysisGroupId,
            resultsetid,
            elementType,
            outputType,
            objectid,
        } = node;
        if (
            !dbid ||
            !analysisGroupId ||
            !resultsetid ||
            !elementType ||
            !outputType ||
            !objectid
        ) {
            throw new Error('Missing required properties for simulation node.');
        }

        const seriesType = this.getSeriesType(node);
        return `simulation${seriesType}('${dbid}', '${analysisGroupId}', '${resultsetid}', '${elementType}', '${outputType}', '${objectid}')`;
    }
}

export class OutputNodeExpressionStrategy implements ExpressionStrategy {
    buildEngineNodeExpression(
        node: OutputGraphNode,
        analyticName?: string,
    ): string {
        const channelId = node.channelId ?? `${analyticName}.${node.name}`;
        const sourceType = InputType.VIRTUAL;
        const name = 'close';
        return `${name}('${channelId}','${sourceType}')`;
    }
}

export class InputNodeExpressionStrategy
    extends SeriesTypeNode
    implements ExpressionStrategy
{
    buildEngineNodeExpression(node: InputGraphNode): string {
        const seriesType = this.getSeriesType(node);
        const sourceType = node?.sourceType ?? InputType.PHYSICAL;
        const channelId = node.channelId ?? '';
        return `${seriesType}('${channelId}','${sourceType}')`;
    }
}
